import { VIP_ICONS_ENUM } from '@mg/web-components/types'
import { ShopConfig } from '~/module/shopConfig/shopConfigPlugin'
import { Shops } from '~/config/shops'

const getVipIcon = (shopConfig: ShopConfig) => {
  return shopConfig.shopId === Shops.SI10SI ? VIP_ICONS_ENUM.VIP_TROPHY : ''
}

export default getVipIcon
